import React, { useEffect, useState } from "react";
import "./PastChallenges.css";
import ChallengeBox from "../components/ChallengeBox";
import useFetchData from "../hooks/useFetchData";

import {
  parseChallenges,
  get_all_categories,
  get_all_tags,
} from "../hooks/parseChallenges";
export default function PastChallenges() {
  let genres = ["Genre 1", "Genre 2", "Genre 3"];

  type Challenge = {
    title: string;
    difficulty: string;
    hints: string[];
    tags: string[];
    description: string;
    // key pair value for attachments
    attachments?: {
      [key: string]: string;
    };
  };
  type Challenges = {
    [genre: string]: Challenge[];
  };

  // fetch challenges
  const data = useFetchData("api/all/challenges");
  const categories = get_all_categories(data.data);
  // parse the challenges
  const Challenges = parseChallenges(data.data);
  const tags = get_all_tags(data.data);
  const loading = data.loading;
  const error = data.error;

  let [activeTags, setActiveTags] = useState<string[]>([]);

  const tagClick = (e: React.MouseEvent<HTMLDivElement>) => {
    // add to active tags and remove if already present
    const tag = e.currentTarget.textContent as string;
    if (activeTags.includes(tag)) {
      setActiveTags(activeTags.filter((t) => t !== tag));
    } else {
      setActiveTags([...activeTags, tag]);
    }
  };
  function handleDropdownClick(event: any): void {
    
    if (
      activeTags.length > 0 &&
      event.currentTarget.textContent == activeTags[0]
    ) {
      setActiveTags([]);

      // reset color for all tags
      document.querySelectorAll(".dropdown-link").forEach((tag) => {
        (tag as HTMLElement).style.color = "var(--lpink)";
      });
    } else {
      setActiveTags([event.currentTarget.textContent as string]);
      document.querySelectorAll(".dropdown-link").forEach((tag) => {
        (tag as HTMLElement).style.color = "var(--lpink)";
      });
      event.currentTarget.style.color = "#ff66cc";
    }
    // uncheck checkbox
    document.getElementById("dropdown")?.click();
    return;
  }

  const ChallengeRender = (genre: string) => {
    return activeTags.length > 0
      ? Challenges[genre]
          ?.filter((challenge: any) =>
            activeTags.every(
              (tag) =>
                challenge.tags.includes(tags) || challenge.event_name == tag
            )
          )
          ?.map((challenge: any, i: number) => (
            <ChallengeBox activeTags={activeTags} {...challenge} key={i} />
          ))
      : Challenges[genre]?.map((challenge: any, i: Number) => (
          <ChallengeBox key={i} activeTags={activeTags} {...challenge} />
        ));
  };

  return (
    <div className="past_cont">
      <h1 className="active">Challenges</h1>
      {/* <Dropdown options={["No Filter",...tags]} onChange={(e) => {if(e.value != "") {setActiveTags([e.value])}}} value="" placeholder="Filter By Event" arrowClassName="arrow" className="dropdown" menuClassName="menu-drop"/> */}
      <div className="dropdown">
        <input type="checkbox" id="dropdown" />
        <label htmlFor="dropdown" className="dropdown-btn">
          <span>
            {activeTags.length > 0 ? activeTags[0] : "Filter By Event"}
          </span>
          <span className="arrow"></span>
        </label>

        <div className="dropdown-content" role="menu">
          {tags.map((tag, i: number) => (
            <div>
              <a
                className="dropdown-link"
                onClick={handleDropdownClick}
                key={i}
                href="#"
              >
                {tag}
              </a>
            </div>
          ))}
        </div>
      </div>

      <div className="">
        {/* {activeTags.map((tag,i) => (
          <div key={i} className="tags filter active-filter" onClick={tagClick}>
            <div
              style={{
                textShadow:
                  "-1px 0 #27ac32, 1px 0 #27ac32, 0 -1px #27ac32, 0 1px #27ac32",
              }}
            >
              {tag}
            </div>
          </div>
        ))} */}
        {/* add remaining tags */}
        {/* {tags?.map(
          (tag,i) =>
            !activeTags.includes(tag as string) && (
              <div key={i} className="tags filter" onClick={tagClick}>
                <div>{tag as string}</div>
              </div>
            )
        )} */}
        {/* add a f */}
      </div>
      <div className="">
        {/* loading */}

        {loading && <div>Loading...</div>}
        {/* error */}

        {categories.map((genre: any, i) => (
          <div key={i} className="genre_cont">
            {(() => {
              const chal = ChallengeRender(genre);

              return (
                <>
                  <h2 className="genre_heading active">
                    {chal.length > 0 && genre}
                  </h2>
                   <div className="challenges_cont">{chal}</div>
                  {chal.length > 0 && <div className="line" style={{}}></div>}
                </>
              );
            })()}
          </div>
        ))}
      </div>
    </div>
  );
}
